import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Password } from '../Password'
import { ConfirmPassword } from '../ConfirmPassword'
import { Header } from '../../Header'
import { Separator } from '../Separator'
import config from 'SRC/config/config.json'

export const Container = () => {
  const { t } = useTranslation('common')

  return (
    <>
      <Header key='header'>{t('Promjena šifre')}</Header>
      <div className='form-sifra' key='password'>
        <Password />
        <ConfirmPassword />
      </div>
      <Separator key='separator' />
    </>
  )
}

Container.displayName = 'ChangePassword'
